import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

// Store.
import { bannerErrors } from 'app/client/store/actions/errorActions';

/**
 * Report the download errors that are not shown elsewhere on a `WaToast` given the
 * returned ref. An expired session and the banner errors are already reported.
 */
export default () => {
  const { t } = useTranslation();
  // The toast stack owns its items, so they are created on it instead of rendered.
  const toast = useRef(null);

  const report = (result) => {
    const unreported = result?.errors.filter(
      ({ status }) => status !== '401' && !bannerErrors[status],
    );

    if (unreported?.length) {
      toast.current?.create(t('core:error.exception.message'), { variant: 'danger' });
    }
  };

  return [toast, report];
};
